module.exports = __webpack_public_path__ + "img/exclusive.1562c34a.svg";